<template>
  <span v-if="count > 0" class="badge">
    {{ count }}
  </span>
</template>

<script>
  export default {
    props: {
      itemQuantity: {
        type: Number,
        required: true,
        default: 0
      }
    },
    data() {
      return {
        count: this.itemQuantity
      }
    },
    mounted() {
      document.addEventListener('cartupdate', (event) => {
        this.count = event.detail.item_count
      })
    }
  }
</script>
